import { combineReducers } from 'redux';
import studentsReducer from './students';
import schoolsReducer from './schools';

const rootReducer = combineReducers({
    students: studentsReducer,
    schools: schoolsReducer,
});

export default rootReducer;